<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
import Api from './api/Api'
import { TCA, TCACErr } from './../public/static/TopESA/topEsa.min'
export default {
  data () {
    return {
      screenWidth: null,
      screenHeight: null,
    }
  },
  created () {
    let queryRegion = this.$common.searchQueryString('region')
    if (queryRegion === 'puyang') {
      window.localStorage.setItem('view-mode', 'puyang')
      console.log('set puyang')
    } else {
      window.localStorage.removeItem('view-mode')
    }
  },
  mounted () { 
    this.screenWidth = document.body.clientWidth
    this.screenHeight = document.body.clientHeight
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
      })()
    }
    this.connectTopESA()
    Vue.prototype.$Api = Api
    this.updateConfigs()
  },
  watch: {
    screenWidth: {
      handler: function (val) {
        this.$store.dispatch('setScreenWidth', val)
      },
      immediate: true
    },
    screenHeight: {
      handler: function (val) {
        this.$store.dispatch('setScreenHeight', val)
      },
      immediate: true
    }
  },
  methods: {
    updateConfigs () {
      if (this.$store.getters.sysConfigs.TITLE) {
        document.title = this.$store.getters.sysConfigs.TITLE
      }
      if (this.$store.getters.sysConfigs.THEME) {
        console.log(this.$store.getters.sysConfigs.THEME)
        let themeCssUrl = `static/css/app.${this.$store.getters.sysConfigs.THEME}.css`
        let newStyleElement = document.createElement('link')
        newStyleElement.setAttribute('rel', 'stylesheet')
        newStyleElement.setAttribute('href', themeCssUrl)
        document.head.appendChild(newStyleElement)
      }
    },
    connectTopESA () {
      this.TopESAConfig()
    },
    TopESAConfig () {
      var config = {
        license: 'MIIF6gYJKoZIhvcNAQcCoIIF2zCCBdcCAQExDjAMBggqgRzPVQGDEQUAMIIBLwYJKoZIhvcNAQcBoIIBIASCARx7Iklzc3VlciI6IigoKC4qQ0495oCd5Yib572R6IGUXFzvvIjljJfkuqxcXO+8ieenkeaKgOWPkeWxleaciemZkOWFrOWPuENBLiopfCguKk9VPeaKgOacr+mDqC4qKXwoLipPPeaAneWIm+e9keiBlFxc77yI5YyX5LqsXFzvvInnp5HmioDlj5HlsZXmnInpmZDlhazlj7guKil8KC4qQz1DTi4qKSl7NH0pIiwidmVyc2lvbiI6IjEuMC4wLjEiLCJzb2Z0VmVyc2lvbiI6IjMuMS4wLjAiLCJub3RhZnRlciI6IjIwMzgtMDktMDQiLCJub3RiZWZvcmUiOiIyMDE4LTA5LTA0Iiwibm9BbGVydCI6InRydWUifaCCA0QwggNAMIIC5aADAgECAhRfJZzazIK7fvMFswB7i47Jvfm18jAMBggqgRzPVQGDdQUAMFUxJjAkBgNVBAMMHeWkqeivmuWuieS/oea1i+ivlVNNMueUqOaIt0NBMQ4wDAYDVQQLDAVUT1BDQTEOMAwGA1UECgwFVE9QQ0ExCzAJBgNVBAYTAkNOMB4XDTE0MDkyNjA3NDYwOFoXDTE1MDkyNjA3NDYwOFowMTEYMBYGA1UEAwwPU2lnbkVTQTIwMTQwOTI3MRUwEwYDVQQKDAzlpKnor5rlronkv6EwWTATBgcqhkjOPQIBBggqgRzPVQGCLQNCAASWFnhS5iMvZk7nfmotCwXi6MYYJzuh3EBm7EIZeH73ic6FcdAss7f8b1mOcu5d6gMHefQGyPiJuhbZf8ADkoWJo4IBszCCAa8wCQYDVR0TBAIwADALBgNVHQ8EBAMCBsAwgYoGCCsGAQUFBwEBBH4wfDB6BggrBgEFBQcwAoZuaHR0cDovL1lvdXJfU2VydmVyX05hbWU6UG9ydC9Ub3BDQS91c2VyRW5yb2xsL2NhQ2VydD9jZXJ0U2VyaWFsTnVtYmVyPTVBNDdFQ0YxMDU4MDRBNUM2QTVCMjI5MjlCNzVERjBERkJDMEQ3OTYwVwYDVR0uBFAwTjBMoEqgSIZGUG9ydC9Ub3BDQS9wdWJsaWMvaXRydXNjcmw/Q0E9NUE0N0VDRjEwNTgwNEE1QzZBNUIyMjkyOUI3NURGMERGQkMwRDc5NjBvBgNVHR8EaDBmMGSgYqBghl5odHRwOi8vWW91cl9TZXJ2ZXJfTmFtZTpQb3J0L1RvcENBL3B1YmxpYy9pdHJ1c2NybD9DQT01QTQ3RUNGMTA1ODA0QTVDNkE1QjIyOTI5Qjc1REYwREZCQzBENzk2MB8GA1UdIwQYMBaAFD2JxkfLcYWw2TvWSLCJ2ef+79rZMB0GA1UdDgQWBBRLO+1/h4KGh6ASkrEu5gAl2LURADAMBggqgRzPVQGDdQUAA0cAMEQCIL201xfMjR+Y7Gxuq+1y+SxLqSXfJfMfWpM/K4TuV2GCAiDoPocZ+ReODefsGqhvtQ27OpvcYiA/N1ZB55qbXTKEezGCAUUwggFBAgEBMG0wVTEmMCQGA1UEAwwd5aSp6K+a5a6J5L+h5rWL6K+VU00y55So5oi3Q0ExDjAMBgNVBAsMBVRPUENBMQ4wDAYDVQQKDAVUT1BDQTELMAkGA1UEBhMCQ04CFF8lnNrMgrt+8wWzAHuLjsm9+bXyMAwGCCqBHM9VAYMRBQCgaTAYBgkqhkiG9w0BCQMxCwYJKoZIhvcNAQcBMBwGCSqGSIb3DQEJBTEPFw0xNTA1MDExMDI2NThaMC8GCSqGSIb3DQEJBDEiBCDf6fd50PRSKYtJUB8HVWw+bBJO4ZIMAar3Qb9kehku9TAMBggqgRzPVQGCLQUABEYwRAIgLcPs6OfgL/FCZib2f4zP1FB6mv0uU+zFMWJ3KQqNMBgCILiwg97vl8MMeq+N6JwBN0mIK2Xobk6SvKfSlKbBUMzj',
        exportKeyAble: false,
        disableExeUrl: true
      }
      try {
        TCA.config(config)
        return true
      } catch (e) {
        if (e instanceof TCACErr) {
          this.$Notice.warning({
            title: '未检测到证书助手',
            desc: '请下载并安装证书助手，<b><a href=\'https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/ca/TopESA.zip\'>点击下载</a></b>',
            duration: 5
          })
        } else {
          this.$Message.error('证书错误 !!!')
        }
        return false
      }
    }
  }
}
</script>

<style lang="less">
// @primary-color: #3855b8;
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.pull-right {
  float: right;
}
.padding-top-10 {
  padding-top: 10px;
}
.padding-top-20 {
  padding-top: 20px;
}
.padding-top-50 {
  padding-top: 30px;
}
.inline {
  display: inline-block;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.small {
  font-size: 11px;
}
.font-normal {
  font-weight: normal;
}
.font-white {
  color: #fff !important;
}
.font-grey {
  color: #999 !important;
}
.font-red {
  color: rgb(187, 21, 21);
}
.font-green {
  color: #19be6b;
}
.font-darkgreen {
  color: darkgreen;
}
.font-orange {
  color: orange;
}
.detail-table {
  border-collapse: collapse;
  border-spacing: 0px;
  width: 100%;
  tr {
    border-bottom: 1px solid #efefef;
    td.title {
      padding-right: 15px;
      text-align: right;
      font-weight: bold;
      width: 140px;
      color: #444;
    }
    td {
      padding: 5px;
      color: #777;
    }
  }
}
.brief-table {
  border: 1px solid #dedede;
  border-collapse: collapse;
  border-spacing: 0px;
  width: 100%;
  > tbody > tr:not(:last-child) {
    border-bottom: 1px solid #e2e2e2;
  }
  > tbody > tr:nth-child(2n+2) td:not(.title) {
    background: #f9f9f9;
  }
  > tbody > tr:not(.no-hover) {
    transition: all .3s ease-in-out;
    &:hover {
      background:#e9f0f8;
      > td {
        color: #333;
        background:#e9f0f8 !important;
      }
    }
  }
  > tbody > tr.no-hover {
    transition: none;
    &:hover {
      background: transparent !important;
      > td {
        background: transparent !important;
      }
    }
  }
  td  {
    padding: 8px 8px;
    transition: all .3s ease-in-out;
    border-bottom: 1px solid #dedede;
    border-right: 1px solid #dedede;
    color: #777;
  }
  .title {
    background: #f2f2f2;
    text-align: center;
    font-weight: 700;
    color: #444;
  }
  th {
    // background: #efefef;
    text-align: center;
    font-weight: 700;
    color: #666;
    padding: 5px 8px;
    border-bottom: 2px solid #888888;
  }
  tfoot {
    th {
      border-top: 2px solid #888888;
    }
  }
}
.tab-square.ivu-tabs.ivu-tabs-card {
   .ivu-tabs-bar .ivu-tabs-tab{
    border-radius: 0;
    background: #fff;
  }
  .ivu-tabs-bar .ivu-tabs-tab-active{
    border-top: 1px solid @primaryColor;
  }
  .ivu-tabs-bar .ivu-tabs-tab-active:before{
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: @primaryColor;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.strech-tree.multifunc {
  .ivu-tree-title {
    width: calc(~'100% - 15px');
    .hover-show {
      opacity: 0;
      transition: all .3 linear;
    }
    &:hover {
      .hover-show {
        opacity: 1;
      }
    }
  }
}
.__rail-is-vertical, .__bar-wrap-is-vertical, .__bar-is-vertical {
  z-index: 9999 !important;
}
// .ivu-input:focus, .ivu-btn:focus, .ivu-btn-text:focus, .ivu-tabs-bar:focus,
// .ivu-input:active, .ivu-btn:active, .ivu-btn-text:active, .ivu-tabs-bar:active {
//   outline: none !important;
//   border: none !important;
//   box-shadow: 0 0 0 2px transparent !important; 
// }

.form-table {
  width: 100%;
  border: 1px solid @primaryColor;
  border-collapse: collapse;
  margin-bottom: 30px;
  .table-col {
    &.col-title {
      background: fade(@primaryColor, 10%);
    }
    &.col-content {
      // width: auto;
    }
  }
  .table-header {
    display: table-cell;
    width: 100%;
    font-weight: bold;
    font-size: 16px;
    vertical-align: middle;
    text-align: center;
    height: 48px;
    background: @primaryColor;
    color: #fff;
  }
  .table-row {
    display: flex;
    width: 100%;
    align-items: stretch;
    &:not(:last-child) {
      border-bottom: 1px solid @primaryColor;
    }
  }
  .section-header {
    display: flex;
    width: 100%;
    align-items: stretch;
    font-weight: bold;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    background: fade(@primaryColor, 20%);
    border-top: 1px solid @primaryColor;
    border-bottom: 1px solid @primaryColor;
    position: relative;
    .section-score {
      position: absolute;
      right: 10px;
      top: 15px;
    }
  }
  .form-item {
    display: inline-flex;
    align-items: stretch;
    width: 100%;
    height: 100%;
    margin-bottom: 0;
    border-left: 1px solid @primaryColor;
    &.form-item-50 {
      width: 50%;
    }
    &.form-item-67 {
      width: 66.667%;
    }
    &.form-item-33 {
      width: 33.333%;
    }
    &.form-item-25 {
      width: 25%;
    }
    .ivu-form-item-label {
      border-right: 1px solid @primaryColor;
      background: fade(@primaryColor, 20%);
      height: 100%;
      padding: 8px;
      display: flex;
      align-items: center;
    }
    .ivu-form-item-content {
      margin-left: 0 !important;
      flex: 1;
      padding: 8px;
      .ivu-form-item-error-tip {
        position: relative;
        top: 0;
      }
    }
    &:first-child {
      border-left: none;
    }
    .ivu-form-item.padding0 {
      .ivu-form-item-content {
        padding: 0;
      }
    }
    .inline-formitem {
      display: inline-block;
      .ivu-form-item-label {
        width: 180px;
        text-align: right;
        background: none;
        display: inline-block;
        border: none;
      }
      .ivu-form-item-content {
        display: inline-block;
      }
      .ivu-form-item.padding0 {
        padding: 0;
      }
    }
    .options-static {
      display: inline-block;
      margin-right: 15px;
    }
  }
  .item-extra-td {
    padding: 8px;
    display: flex;
    flex-direction: row;
  }
  .description {
    color:#666;
    font-size: 12px;
    flex: 1;
  }
  .score {
    width: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
.question-list-item-list {
  display: flex;
  flex-direction: column;
  .question-list-item {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
  }
  &.adjust {
    color: rgb(187, 21, 21);
  }
}
.result-page {
  width: 100%;
  height: 580px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .result-icon {
    width: 120px;
    height: 120px;
    border-radius: 60px;
    background: #e2e2e2;
    color: #fff;
    margin: 40px auto;
    &.success {
      background: @successColor;
    }
  }
  .result-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
  }
  .result-message {
    color: #777;
    font-size: 14px;
    text-align: center;
  }
  .result-extra {
    width: 80%;
    margin-top: 40px;
    background: #efefef;
    padding: 16px;
    font-size: 12px;
    color: #777;
  }
}
.inline-form-item {
  display: block;
  margin-right: 5px;
  margin-bottom: 24px !important;
  .ivu-form-item-label {
    display: inline-block;
  }
  .ivu-form-item-content {
    display: inline-block;
    width: calc(100% - 80px);
  }
}

@media print {
  @page {
    margin: 1cm; /* 设置页面边距 */
    counter-increment: page; /* 创建页码计数器 */
  }
  body {
    font-size: 14pt;
    color: black;
  }
  .brief-table {
    border: 1px solid #dedede;
    border-collapse: collapse;
    border-spacing: 0px;
    width: 100%;
    > tbody > tr:not(:last-child) {
      border-bottom: 1px solid #e2e2e2;
    }
    > tbody > tr:nth-child(2n+2) td:not(.title) {
      background: #f9f9f9;
    }
    > tbody > tr:not(.no-hover) {
      transition: all .3s ease-in-out;
      &:hover {
        background:#e9f0f8;
        > td {
          color: #333;
          background:#e9f0f8 !important;
        }
      }
    }
    > tbody > tr.no-hover {
      transition: none;
      &:hover {
        background: transparent !important;
        > td {
          background: transparent !important;
        }
      }
    }
    td  {
      padding: 8px 8px;
      transition: all .3s ease-in-out;
      border-bottom: 1px solid #dedede;
      border-right: 1px solid #dedede;
      color: #777;
    }
    .title {
      background: #f2f2f2;
      text-align: center;
      font-weight: 700;
      color: #444;
    }
    th {
      // background: #efefef;
      text-align: center;
      font-weight: 700;
      color: #666;
      padding: 5px 8px;
      border-bottom: 2px solid #888888;
    }
    tfoot {
      th {
        border-top: 2px solid #888888;
      }
    }
  }
}
</style>
